const TOOLTIP_MESSAGES = {}

TOOLTIP_MESSAGES.ausstattung = `<p class="mb-2">Über die gehobene Ausstattung hinaus enthält die Luxusausstattung Parkett, Textil- oder Natursteinbelag der oberen Preisklasse, eine Klimaanlage sowie eine Schallschutzverglasung und elektrische Rollläden. Zudem sind Stuckdecken oder Wandvertäfelungen und mehrere Bäder und WCs in hochwertiger Ausführung (z.B. Whirlpool) ausschlaggebend für die Einordnung in diese Ausstattungskategorie.</p>

<b>Checkliste:</b>
<ul class="list-disc mt-1 ml-6">
    <li>Böden der oberen Preisklasse</li>
    <li>Schallschutzverglasung</li>
    <li>Mehrere Bäder in hochwertiger Ausführung</li>
</ul>
`

TOOLTIP_MESSAGES.letzteSanierung = `<p>Das Jahr der <b>letzten Sanierung</b> ist das Jahr, in dem Ihre Immobilie das letzte Mal <b>vollständig</b> saniert wurde. Wurde die Immobilie nur teilweise bzw. etappenweise über mehrere Jahre hinweg modernisiert, sollten Sie stattdessen ein <a href="https://www.ohne-makler.net/ratgeber/verkauf/fiktives-baujahr/" target="_blank" class="text-secondary font-semibold">Fiktives Baujahr</a> als mittleren Wert der Jahre bestimmen, in denen einzelne Gewerke saniert oder modernisiert wurden.</p>
`

TOOLTIP_MESSAGES.ustIdnr = `<p>Wird benötigt, falls sich Ihr Unternehmen nicht in Deutschland, aber in der EU, befindet</p>
`

export default TOOLTIP_MESSAGES
